import { StepRoute } from '../models/step-route.model';
import { COUNTRY_CODE } from '@cemex-core/cmx-api';
import { ORDER_BUILDER_ROUTES } from '../constants/order-builder-routes';
import { repo as mxRepo } from './routes/mx/repo';
import { repo as coRepo } from './routes/co/repo';
import { repo as usRepo } from './routes/us/repo';
import { repo as ukRepo } from './routes/uk/repo';
import { repo as ilRepo } from './routes/il/repo';
import { repo as frRepo } from './routes/fr/repo';
import { repo as deRepo } from './routes/de/repo';
import { repo as czRepo } from './routes/de/repo';

interface IStepRepoConfig {
  [countryCode: string]: {
    [businessLine: string]: {
      [deliveryMethod: string]: StepRoute[];
    };
  };
}

export const repo: IStepRepoConfig = {
  [COUNTRY_CODE.MEXICO]: mxRepo,
  [COUNTRY_CODE.COLOMBIA]: coRepo,
  [COUNTRY_CODE.USA]: usRepo,
  [COUNTRY_CODE.UNITED_KINGDOM]: ukRepo,
  [COUNTRY_CODE.ISRAEL]: ilRepo,
  [COUNTRY_CODE.FRANCE]: frRepo,
  [COUNTRY_CODE.GERMANY]: deRepo,
  [COUNTRY_CODE.CZECH_REPUBLIC]: czRepo,
};

export const defaultStepsRoutes: StepRoute[] = [
  {
    name: 'views.builder.product_line',
    route: ORDER_BUILDER_ROUTES.BusinessLine,
  },
  {
    name: 'views.builder.location',
    route: ORDER_BUILDER_ROUTES.Location,
  },
  {
    name: 'views.builder.specifications',
    route: ORDER_BUILDER_ROUTES.Specification,
  },
  {
    name: 'views.builder.review',
    route: ORDER_BUILDER_ROUTES.Review,
  },
  {
    name: 'views.builder.summary',
    route: ORDER_BUILDER_ROUTES.Summary,
  },
];
